// This is for allowing Rails forms to be submitted using CMD+Enter or CTRL+SHIFT+Enter.

onDomLoad(() => {
  document.querySelectorAll('form').forEach((form) => {
    form.addEventListener('keydown', (e) => {
      if (
        (e.key === 'Enter' && e.ctrlKey && e.shiftKey) || // Windows + Linux
        (e.key === 'Enter' && e.metaKey) // Mac
      ) {
        form.submit()
      }
    })
  })
})
